import React from "react";
import "./style.scss";
import hand from "../../Assets/Icons/hand.png";
import divesh from "../../Assets/Icons/divesh.svg";
const Banner = () => {
  return (
    <div className="banner_container">
      <div className="banner_main">
        <div className="dots_container">
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
          <div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
            <div className="banner_dots"></div>
          </div>
        </div>
        <div className="banner_text">
          <div className="banner_top_heading"  >
            <img className="banner_hand" src={hand} alt="hand" />
            <p>Hello, its </p>
            <img className="banner_divesh" src={divesh} alt="divesh" />
          </div>
          <div>
            <h1>UI/UX Designer</h1>
          </div>
          <div className="banner_detail">
            <p>
              Hello, this is Divesh. I am a UI/UX designer, dedicated to
              crafting interfaces that are not only visually appealing but also
              user-friendly. I prioritize the needs and preferences of users in
              my design process, aiming to deliver a seamless and delightful
              user experience.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
